// ============================================================
// ParkDeleteModal.js — Modale de confirmation de suppression
// Affiche un avertissement avant de supprimer définitivement
// un parc. L'action est irréversible.
// Props :
//   show     — booléen contrôlant l'affichage de la modale
//   onHide   — ferme la modale sans supprimer
//   client   — objet parc concerné (pour afficher son nom)
//   onDelete — callback déclenché lors de la confirmation
// ============================================================

import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const ParkDeleteModal = ({ show, onHide, client, onDelete }) => (
  <Modal show={show} onHide={onHide}>
    {/* En-tête : affiche le nom du parc à supprimer */}
    <Modal.Header closeButton>
      <Modal.Title>{client && client.name}</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      {/* Message d'avertissement sur l'irréversibilité de l'action */}
      Voulez vous vraiment supprimer ce parcours?
      cette action ne sera pas reversible
      <br/>
      {/* Annuler : ferme la modale sans rien faire */}
      <Button style={{ margin: "5px" }} variant="secondary" onClick={onHide}>Annuler</Button>
      {/* Confirmer : appelle onDelete qui envoie la requête DELETE à l'API */}
      <Button style={{ margin: "5px" }} variant="danger" onClick={onDelete}>Valider la suppression.</Button>
    </Modal.Body>
  </Modal>
);

export default ParkDeleteModal;
